import { faCircleInfo, faSpinner } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState } from 'react'
import { deleteCache, getCache } from '../../../utils/APIs/cache'
import { toastSuccess } from '../../../utils/toast'
import { setPageTitle } from '../../../utils/utilities'
import Tooltip from '../../Utilities/Tooltip'

const Cache = () => {
  setPageTitle('Admin | Cache')

  return (
    <div className="flex w-full pb-5">
      <div className="flex flex-col h-full w-full">
        <div className="shrink">
          <div className="flex items-center">
            <h2 className="mb-1 mr-3">View Cache</h2>
            <Tooltip tooltipContent="This section shows data that is currently stored in the site's cache.">
              <FontAwesomeIcon icon={faCircleInfo} className="text-white" />
            </Tooltip>
          </div>
          <ViewCache />
        </div>
        <div className="shrink">
          <div className="flex items-center">
            <h2 className="mb-1 mr-3">Bust Cache</h2>
            <Tooltip tooltipContent="Enter a cache name (e.g., 'mod-chats') in the field below to clear all its cached values.">
              <FontAwesomeIcon icon={faCircleInfo} className="text-white" />
            </Tooltip>
          </div>
          <BustCacheForm />
        </div>
      </div>
    </div>
  )
}

const BustCacheForm = () => {
  const [loading, setLoading] = useState(false)
  const [setting, setSetting] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    const response = await deleteCache(setting)
    if (response && response.status === 200) {
      setLoading(false)
      setSetting('')
      toastSuccess('Cache busted.')
    }
  }

  return (
    <div className="mb-auto flex gap-2">
      <form
        onSubmit={handleSubmit}
        autoComplete="off"
        className="relative flex flex-grow items-stretch focus-within:z-10 gap-2"
      >
        <input
          aria-label="Chat form input"
          value={setting}
          onChange={(e) => setSetting(e.target.value)}
          className="grow input"
          placeholder="Setting"
          required
        />
        <button
          type="submit"
          aria-label="Bust Cache"
          className="button-confirm"
        >
          Bust Cache
        </button>
      </form>
      {loading && (
        <div className="flex items-center whitespace-nowrap bg-green-500 px-4 py-2 font-bold text-white transition-all hover:bg-green-600 active:bg-green-700">
          <FontAwesomeIcon
            className="mr-2 h-5 cursor-pointer"
            icon={faSpinner}
            spin
          />
        </div>
      )}
    </div>
  )
}

const ViewCache = () => {
  const [keys, setKeys] = useState([])
  const [theCache, setTheCache] = useState('')

  useEffect(() => {
    getCacheKeys()
  }, [])

  const getCacheKeys = async () => {
    const response = await getCache()
    if (response && response.status === 200) {
      setKeys(response.data)
    }
  }

  const handleClick = async (setting) => {
    const response = await getCache(setting)
    if (response && response.status === 200) {
      setTheCache(JSON.stringify(response.data))
    }
  }

  return (
    <div className="mb-auto flex flex-col gap-2">
      <div className="flex gap-1">
        {keys.map((key) => {
          return (
            <button
              key={key}
              className="button-outline"
              onClick={() => handleClick(key)}
            >
              {key}
            </button>
          )
        })}
      </div>
      {theCache && (
        <textarea
          className="flex w-full pb-5"
          value={theCache}
          onChange={(e) => handleClick(e.target.value)}
          disabled
        />
      )}
      <div />
    </div>
  )
}

export default Cache
